import Vue from 'vue'
import axios from 'axios'

var theme = localStorage.getItem('echarts-theme') || Vue.prototype.$config.echarts && Vue.prototype.$config.echarts.theme
const registerTheme = ()=>{  
  if(theme){
    axios.get(`/assets/echart/${theme}.json`).then(res=>{
      window.echarts.registerTheme(theme,res.data)
    }).catch(()=>{
      theme = ''
    })
  }
}
registerTheme()

const initEcharts = (document)=>{
  var myChart = null
  if(document){
    myChart = window.echarts.init(document, theme || 'light')
  }
  return myChart
}
export default{
  init: initEcharts
}